import { capitalize } from '../misc.js';

export default function (...args)
{
	return {
		setValue(value, _this = this)
		{
			let has_changed = !(new RegExp(value, 'i').test(this.getValue()));
			this.safeProtoCall(has_changed ? capitalize(value) : value, _this);
		}
	};
}

